<div class="modal-header bg-danger">
    <h4 class="modal-title white" id="myModalLabel1">{{'delete_modal.title'|translate}}</h4>
    <button type="button" class="close" aria-label="Close"
            (click)="closePopup()">
    <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <h5>{{'delete_modal.message'|translate}}</h5>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn grey btn-outline-warning"
            (click)="closePopup()">{{'button.cancel'|translate}}</button>
    <button type="button"
            class="btn btn-outline-danger" (click)="onDeleteJourney()">{{ 'button.ok' | translate}}</button>
</div>